import React, { useState } from 'react';
import { Box, Typography } from '@material-ui/core';
import info from '../redesign-5.2/images/infoBlue.png';
import noticeStyles from './noticeStyles';
import { useApolloClient } from '@apollo/client';

const AlertOfForgotPassword = ({ email }) => {
    const classes = noticeStyles();
    const [isCanceled, setIsCanceled] = useState(false);
    const [isClicked, setIsClicked] = useState(false);
    const graphql = useApolloClient();

    const closeAction = () => {
        setIsCanceled(true);
    };

    const handleRegister = () => {
        window.location.href = '/register';
    };
    return (
        <>
            {!isCanceled && (
                <Box className={classes.alertContainer}>
                    <Box className={classes.noticeElements}>
                        <Box component='img' src={info} alt='info' className={classes.info} />
                        <Box className={classes.alertText}>
                            If you haven’t received an email, please check your spam folder. If it’s
                            not there, you may not be registered.
                            <Typography
                                component='span'
                                className={classes.textBold}
                                onClick={handleRegister}
                            >
                                Register for your eir account.
                            </Typography>{' '}
                        </Box>
                    </Box>
                </Box>
            )}
        </>
    );
};

export default AlertOfForgotPassword;
